
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  Grid, Button, Modal, createStyles, AspectRatio, Group, Box } from '@mantine/core';
import { FileSettings   } from 'tabler-icons-react';
import intl from "react-intl-universal";
import { set_modal_stapel_setup_open } from "../../slice/mainslice";

const useStyles = createStyles((theme) => ({
  sigcountdiv: {
    maxWidth: `25px`,
  },
  trackLabelsize: {
    fontSize: `12px`,
  },
}));




const SetupPrepareStapelDocs = (props: any) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const stapels = useSelector((state: any) => state.user.userhavetostapelsigndocs) || []
  const activeSetupId = useSelector((state: any) => state.user.setupmodalstapelopen)
  const myKey = props.item.stapelId ?? props.item.localStapelId
  const isOpen = activeSetupId === myKey
  const prevIsOpen = useRef(false);

  //console.log("isOpen:", isOpen, "activeSetupId:", activeSetupId, "myKey:", myKey)

  useEffect(() => {
    // Nur wenn dieses Modal vorher offen war und jetzt geschlossen wurde
    if (prevIsOpen.current === true && isOpen === false) {
      dispatch({
        type: "SIGNALR_SETUP_STAPEL_SIG_PREPARED",
        payload: { IsSigPrepared: true, StapelId: props.item.stapelId },
      });
    }
    prevIsOpen.current = isOpen;
  }, [isOpen, dispatch, props.item.stapelId]);
    

    

 const stapel = stapels.filter((obj: { id: any; }) => {
   // return obj.role !== "notar" && obj.role !== "gast"
   return obj.id === props.item.stapelId 
    });




 const addEditOnlyParam = (url: string): string => {
  const hashIndex = url.indexOf('#');
  if (hashIndex === -1) {
    return url + '?editonly=1';
  }
  return url.slice(0, hashIndex) + '?editonly=1' + url.slice(hashIndex);
  };  
  
  const stapelsetupurl = addEditOnlyParam(stapel[0]?.stapelSignLink)
  const stapelhasprepared = stapel[0]?.isSigPrepared || false;

  let color = "gray"
  if(stapelhasprepared){
    color = "green"
  }

   //
  
//console.log("stapelsetupurl:", stapelsetupurl)


    /**
     * Handle Modal Window.
     *
     * @return {void} 
     */
    const handleOpenFull = () => {
      dispatch(set_modal_stapel_setup_open(myKey));
    };

    
    const closeOpenFull = () => {
        //dispatch(set_modal_stapel_setup_open(false));
    };
    
      
   //  console.log("checked",checked)

        return (
            <>
              
              
                 
              <FileSettings color={color} onClick={() => handleOpenFull()}/>
            
                <Modal
                    opened={isOpen}
                    onClose={() => closeOpenFull()}
                    title=""
                    fullScreen
                    withCloseButton={false}
                    closeOnClickOutside={false}
                    transitionProps={{ transition: 'fade', duration: 200 }}

                    >

                    {
                    /*
                    styles={(theme) => ({ 
                      inner:{
                        paddingTop: `1vw !important`,
                        paddingBottom: `1vw !important`,
                        paddingLeft: `1vw !important`,
                        paddingRight: `1vw !important`,
                      }
                    })}


                    <Group position="right" >
                   
                        <Button  color="green" onClick={closeOpenFull}>{intl.get('SETSIGBLOCKDOC_MOD_BUTYES')}</Button>
                    </Group>
                    */}
                     
                        
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{
                            width: '100%',
                            maxWidth: 1920,
                            position: 'relative',
                            paddingTop: 'min(56.25%, calc(56.25vw))', // 16:9
                          }}
                        >
                          <iframe
                            key={stapelsetupurl}
                            src={stapelsetupurl}
                            title="Testraum"
                            allow="camera;microphone;display-capture"
                            allowFullScreen
                            frameBorder="0"
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              overflow: 'auto',
                            }}
                          />
                        </Box>
                      </Box>
                        

                 
                    </Modal>

                
            </>
        );
    };

    


export default SetupPrepareStapelDocs;